import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import DateTimeDisplay from '../../../../components/date-time-display';


class BotVersionRenderer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { value, data } = this.props;
    if (!data) {
      return null;
    }
    if (!value) {
      return (<span className="text-muted">N/A</span>);
    }

    const inner = (<span>{value}</span>);
    if (!data.bot_version_last_used) {
      return inner;
    }

    const tip = (
      <Tooltip id={`version-${data._id}`}>
        <div>Last request on <DateTimeDisplay value={data.bot_version_last_used} format="longWithTime" /></div>
      </Tooltip>
    );

    return (
      <OverlayTrigger trigger={['hover', 'focus']} placement="top" overlay={tip}>
        {inner}
      </OverlayTrigger>
    );
  }
}

BotVersionRenderer.propTypes = {
  value: PropTypes.string,
  data: PropTypes.shape({
    _id: PropTypes.string.isRequired,
    display_name: PropTypes.string,
    name: PropTypes.string,
    is_demo: PropTypes.bool,
    tru_voice_clients: PropTypes.arrayOf(PropTypes.shape({})),
  }),
};
BotVersionRenderer.defaultProps = {
  value: null,
  data: null,
};

export default BotVersionRenderer;
